export default __webpack_public_path__ + "static/media/admi-logo.f3b1fa7a.png";